import { Link } from '@mui/material';
import React from 'react';

const MARKDOWN_LINK_RE = /\[([^\]]+)\]\(([^)]+)\)/g;

function renderNoteContent(content: string): React.ReactNode[] {
  const nodes: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let key = 0;

  const re = new RegExp(MARKDOWN_LINK_RE);
  while ((match = re.exec(content)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(content.slice(lastIndex, match.index));
    }
    const label = match[1];
    const href = match[2];
    const isInternal = href.startsWith('/') || href.startsWith(window.location.origin);
    nodes.push(
      isInternal ? (
        <Link key={`link-${(key += 1)}`} href={href} underline="hover">
          {label}
        </Link>
      ) : (
        <Link
          key={`link-${(key += 1)}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          {label}
        </Link>
      ),
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < content.length) {
    nodes.push(content.slice(lastIndex));
  }

  return nodes.length ? nodes : [content];
}

const AdminNoteContent: React.FC<{ content: string }> = ({ content }) => (
  <>{renderNoteContent(content)}</>
);

export default AdminNoteContent;
